import { render, staticRenderFns } from "./Conteos.vue?vue&type=template&id=56232e3c&scoped=true"
import script from "./Conteos.vue?vue&type=script&lang=ts"
export * from "./Conteos.vue?vue&type=script&lang=ts"
import style0 from "./Conteos.vue?vue&type=style&index=0&id=56232e3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56232e3c",
  null
  
)

export default component.exports